import React from 'react';
import {string} from "prop-types";

export default function PageTitle({pageName}) {
    return (
        <title>CoachingEnglish CMS | {pageName}</title>
    )
}

PageTitle.propTypes = {
    pageName: string
}